export default __webpack_public_path__ + "45fc5ecb73491c5c80b940af0dbdd75e.svg";